import {PWD_STRENGTH_LIST} from '@/constants';
import {PwdStrengthConditionType} from '@/enums';

export const getPasswordStrength = (password?: string) => {
  const passConditions: PwdStrengthConditionType[] = [];

  if (!password) {
    return passConditions;
  }

  if (password.length >= 8) {
    passConditions.push(PwdStrengthConditionType.minLength);
  }

  PWD_STRENGTH_LIST.map((condition) => {
    const count = password.match(condition.regexp)?.length;

    if (count) {
      passConditions.push(condition.type);
    }

    return false;
  });

  return passConditions;
};

export const getPwdStrengthLevel = (conditions: PwdStrengthConditionType[]) => {
  if (!conditions.includes(PwdStrengthConditionType.minLength)) {
    return 0;
  }

  return Math.max(conditions.length - 2, 0);
};

export const hasInvalidCharacterInPwd = (password?: string) => {
  if (!password) {
    return false;
  }

  let passCount = 0;

  PWD_STRENGTH_LIST.map((condition) => {
    const count = password.match(condition.regexp)?.length;

    if (count) {
      passCount += count;
    }

    return false;
  });

  return passCount !== password.length;
};

export const isMyfcEmailAccount = (email?: string) => {
  return !!(email && email?.endsWith('@myfranchise.kr'));
};
